import { LAYOUT_LIST, TEXT } from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import {
  KICKER_HINT,
  OPTIONAL_TEXT_FIELDS,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

export const Statement2: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(
              {
                ...item,
                title: '',
                subtitle: '',
                body: ''
              } as ItemOfType<'Card'>,
              {
                width: '80%',
                height: 'auto',
                padding: { _: '0px', md: '80px' },
                extraItems: [
                  {
                    id: `subtitle_${item.id}`,
                    type: TEXT,
                    values: {
                      ...optionalFieldValues(optional, 'subtitle', KICKER_HINT),
                      value: item.subtitle,
                      variant: 'sub_heading'
                    },
                    items: []
                  },
                  {
                    id: `title_${item.id}`,
                    type: TEXT,
                    values: {
                      ...optionalFieldValues(optional, 'title'),
                      value: item.title,
                      variant: 'heading1'
                    },
                    items: []
                  },
                  {
                    id: `body_${item.id}`,
                    type: TEXT,
                    values: {
                      ...optionalFieldValues(optional, 'body'),
                      value: item.body
                    },
                    items: []
                  }
                ]
              }
            )
          ]
        };
      default:
        return null;
    }
  });
};
